import { PayInfo } from '@comp/PayButtons';
import { OnSubmit } from '@hooks/useOnSubmit';
import './style.scss';
import { UseApplePay } from './utills/UseApplePay';

type ApplePayButtonProps = {
  payInfo: PayInfo;
  onSubmit: OnSubmit;
  nomadLife?: boolean;
};

const ApplePayButton = (props: ApplePayButtonProps) => {
  const { onSubmit, payInfo, nomadLife } = props;
  const { sendPay } = UseApplePay({
    onSubmit,
    payInfo
  });

  return (
    <button
      type="button"
      className={`apple-pay-button apple-pay-button-black ${
        nomadLife ? 'apple-pay-button-nomad' : ''
      }`}
      onClick={sendPay}
    />
  );
};

export default ApplePayButton;
